export default __webpack_public_path__ + "static/media/ConveyorLiftMK2.256.1e4ba9f0.png";